import React, { useState } from "react";
import { submitContact } from "../lib/api";

const ContactPage = () => {
  const [form, setForm] = useState({
    sender_name: "", sender_email: "", sender_phone: "", subject: "", message_body: "",
    category: "general", source: "contact_us",
  });
  const [status, setStatus] = useState("idle");
  const [err, setErr] = useState(null);

  const send = async () => {
    setErr(null);
    if (!form.message_body.trim()) {
      setErr("Tell us what's going on.");
      return;
    }
    setStatus("sending");
    try {
      await submitContact({
        ...form,
        sender_email: form.sender_email || null,
        sender_name: form.sender_name || null,
        sender_phone: form.sender_phone || null,
      });
      setStatus("sent");
      setForm({ sender_name: "", sender_email: "", sender_phone: "", subject: "", message_body: "", category: "general", source: "contact_us" });
    } catch (e) {
      setStatus("error");
      setErr("Something went wrong — we will fix this. Call us: 401-555-0100");
    }
  };

  return (
    <div data-testid="contact-page" style={{ maxWidth: 720, margin: "0 auto", padding: "40px 20px 80px" }}>
      <h1 className="font-display" style={{ fontSize: 56, color: "#0A1628", margin: 0 }}>
        CONTACT US
      </h1>
      <p style={{ fontSize: 19, color: "#5a5d66" }}>
        Real humans read every message. Routes to <strong>contact@nearnow.biz</strong>. We reply within 24 hours.
      </p>

      <div className="nn-card" style={{ marginTop: 18 }}>
        <label className="nn-label">Your name</label>
        <input
          data-testid="contact-name" className="nn-input"
          value={form.sender_name} onChange={(e) => setForm({ ...form, sender_name: e.target.value })}
          placeholder="Joe Plumber"
        />

        <label className="nn-label" style={{ marginTop: 14 }}>Email</label>
        <input
          data-testid="contact-email" className="nn-input" type="email"
          value={form.sender_email} onChange={(e) => setForm({ ...form, sender_email: e.target.value })}
          placeholder="you@example.com"
        />

        <label className="nn-label" style={{ marginTop: 14 }}>Phone (optional)</label>
        <input
          data-testid="contact-phone" className="nn-input" type="tel"
          value={form.sender_phone} onChange={(e) => setForm({ ...form, sender_phone: e.target.value })}
          placeholder="(401) 555-0100"
        />

        <label className="nn-label" style={{ marginTop: 14 }}>Category</label>
        <select
          data-testid="contact-category" className="nn-input"
          value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
        >
          <option value="general">General</option>
          <option value="demo_request">Demo Request</option>
          <option value="billing">Billing</option>
          <option value="bug">Bug Report</option>
          <option value="other">Other</option>
        </select>

        <label className="nn-label" style={{ marginTop: 14 }}>Subject</label>
        <input
          data-testid="contact-subject" className="nn-input"
          value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
          placeholder="One short line"
        />

        <label className="nn-label" style={{ marginTop: 14 }}>Message</label>
        <textarea
          data-testid="contact-message" className="nn-input"
          style={{ minHeight: 140 }}
          value={form.message_body} onChange={(e) => setForm({ ...form, message_body: e.target.value })}
          maxLength={500} placeholder="Real talk. Plain English."
        />

        {err && <p data-testid="contact-error" style={{ color: "#A32D2D", marginTop: 12 }}>{err}</p>}
        {status === "sent" && (
          <p data-testid="contact-success" style={{ color: "#1A7A4A", marginTop: 12, fontSize: 18 }}>
            ✓ We got it. Routes to contact@nearnow.biz.
          </p>
        )}

        <button
          data-testid="contact-submit"
          className="btn-gold tap"
          style={{ marginTop: 18, width: "100%" }}
          disabled={status === "sending" || !form.message_body.trim()}
          onClick={send}
        >
          {status === "sending" ? "SENDING..." : "SEND MESSAGE"}
        </button>

        <p style={{ fontSize: 13, color: "#8a8d96", marginTop: 14 }}>
          <span className="mock-badge">MOCK</span> SendGrid will forward to contact@nearnow.biz once SENDGRID_API_KEY is set.
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
